import getBlobMIMEType from './getBlobMIMEType';

export default function createFileUrl(base64Content) {
	const byteCharacters = atob(base64Content);
	const byteArrays = [];
	const sliceSize = 512;

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		const slice = byteCharacters.slice(offset, offset + sliceSize);

		const byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		byteArrays.push(byteArray);
	}

	const blob = new Blob(byteArrays, {
		type: getBlobMIMEType(base64Content),
	});
	return URL.createObjectURL(blob);
}
